import { TOpportunitiesV3Indicators } from 'integration/resources/opportunitiesV3'

const PRODUCTIVITY_ALLOWED_TITLES = new Set(['producao', 'ip spf'])

const APNEF_HIDDEN_TITLE_PATTERNS = ['apnf 10.3', 'apnef 10.3']

const normalizeIndicatorTitle = (value?: string): string =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()

const isAllowedProductivityIndicator = (title?: string): boolean =>
  PRODUCTIVITY_ALLOWED_TITLES.has(normalizeIndicatorTitle(title))

const isHiddenApnefIndicator = (title?: string): boolean => {
  const normalizedTitle = normalizeIndicatorTitle(title)

  return APNEF_HIDDEN_TITLE_PATTERNS.some((pattern) => normalizedTitle.includes(pattern))
}

export const filterGoodsAndServicesIndicators = (
  indicators?: TOpportunitiesV3Indicators
): TOpportunitiesV3Indicators | undefined => {
  if (!indicators) return undefined

  return {
    ...indicators,
    productivity_summary: {
      ...indicators.productivity_summary,
      items: indicators.productivity_summary.items.filter((item) =>
        isAllowedProductivityIndicator(item.title)
      )
    },
    apnef_diagnosis: {
      ...indicators.apnef_diagnosis,
      items: indicators.apnef_diagnosis.items.filter((item) => !isHiddenApnefIndicator(item.title))
    }
  }
}
